// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// event-summary-attendees
import { eventSummaryRoomFragments } from "./EventSummaryRoom.gql";
import { EventSummaryRow as s } from "./EventSummary.styles";
// util
import { niceRooms } from "@util/event.util";
// material-ui
import { MeetingRoom } from "@material-ui/icons";

interface IProps {
  color?: string;
  attendees: ISchema.IAttendee[];
}
const EventSummaryRoomCmpt = ({ attendees, color }: IProps) => {
  const roomSentence = niceRooms(attendees, 15);
  if (!roomSentence || roomSentence === "") {
    return <span />;
  }
  return (
    <div style={s.container}>
      <MeetingRoom style={{ ...s.icon, color }} htmlColor={color || s.icon.color} />
      <div style={{ ...s.text, color }}>{roomSentence}</div>
    </div>
  );
};

export const EventSummaryRoom = createFragmentContainer<IProps>(
  EventSummaryRoomCmpt,
  eventSummaryRoomFragments,
);
